import { useQuery } from '@tanstack/react-query';
import { fetchInvoiceUploads } from 'services/BookingManagerApi/invoiceUploads';
import { IInvoiceUploadsQueryParams, IInvoiceUploadsResponse } from '../types';

export const INVOICE_UPLOADS_QUERY_KEY = 'invoiceUploads';

export const useInvoiceUploadsQuery = (params: IInvoiceUploadsQueryParams) => {
  return useQuery<IInvoiceUploadsResponse>({
    staleTime: 0,
    gcTime: 0,
    queryKey: [INVOICE_UPLOADS_QUERY_KEY, params.tab, params.offset, params.limit],
    queryFn: () => fetchInvoiceUploads(params),
  });
};
